var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadOutline20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15 8.24a1 1 0 10-1.3 1.52L10 13.316l4.15-3.558a1 1 0 00-1.3-1.518L11 9.826V4a1 1 0 10-2 0v5.826L7.15 8.24zM4 15a1 1 0 100 2h12a1 1 0 100-2H4z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjE1MDgxIDguMjQwNzRDNi43MzE0OCA3Ljg4MTMyIDYuMTAwMTggNy45Mjk4OCA1Ljc0MDc2IDguMzQ5MjFDNS4zODEzNCA4Ljc2ODUzIDUuNDI5OSA5LjM5OTgzIDUuODQ5MjMgOS43NTkyNkwxMCAxMy4zMTcxTDE0LjE1MDggOS43NTkyNkMxNC41NzAxIDkuMzk5ODMgMTQuNjE4NyA4Ljc2ODUzIDE0LjI1OTMgOC4zNDkyMUMxMy44OTk5IDcuOTI5ODggMTMuMjY4NiA3Ljg4MTMyIDEyLjg0OTIgOC4yNDA3NEwxMSA5LjgyNTc4VjRDMTEgMy40NDc3MSAxMC41NTIzIDMgMTAgM0M5LjQ0NzczIDMgOS4wMDAwMiAzLjQ0NzcxIDkuMDAwMDIgNFY5LjgyNTc4TDcuMTUwODEgOC4yNDA3NFpNNCAxNUMzLjQ0NzcyIDE1IDMgMTUuNDQ3NyAzIDE2QzMgMTYuNTUyMyAzLjQ0NzcyIDE3IDQgMTdIMTZDMTYuNTUyMyAxNyAxNyAxNi41NTIzIDE3IDE2QzE3IDE1LjQ0NzcgMTYuNTUyMyAxNSAxNiAxNUg0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgDownloadOutline20 as ReactComponent };